module.exports = __webpack_public_path__ + "img/tick-green.5dc39d45.svg";